import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { MdDownload, MdRemoveRedEye } from 'react-icons/md';
import RoundButton from '@components/RoundButton';
import { StatusColor } from '@styles/colors';
import { WrapperStatus, ContainerStatus, Status } from './styles';

const StatusDownload = {
  PENDING: { name: 'Pendente', color: StatusColor.pending },
  PROCESSING: { name: 'Processando', color: StatusColor.processing },
  FAILED: { name: 'Falhou', color: StatusColor.failed },
  COMPLETED: { name: 'Concluído', color: StatusColor.completed },
};

interface Props {
  initialRecord: any;
  api: any;
  handleDownload: (doc: any) => void;
  setError: (err: string) => void;
}

const DownloadRow: React.FC<Props> = ({
  initialRecord,
  api,
  handleDownload,
  setError,
}) => {
  // O React Query assume o controle do dado aqui
  const { data: record } = useQuery({
    queryKey: ['downloadStatus', initialRecord.id],
    queryFn: async () => {
      const resp = await api.get(`/downloads/${initialRecord.id}`);
      return resp.data;
    },
    // Polling a cada 3 segundos se estiver processando
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'completed' || status === 'failed' ? false : 3000;
    },
    initialData: initialRecord,
    enabled:
      !!initialRecord.id &&
      initialRecord.status !== 'completed' &&
      initialRecord.status !== 'failed',
  });

  const statusObj =
    StatusDownload[record.status.toUpperCase() as keyof typeof StatusDownload];

  return (
    <tr>
      <td>{record.id}</td>
      <td>{format(new Date(record.createdAt), 'dd/MM/yyyy HH:mm')}</td>
      <td>{record.description}</td>
      <td>
        <WrapperStatus>
          <ContainerStatus>
            {format(
              new Date(record.finishedAt || record.updatedAt),
              'dd/MM/yyyy HH:mm'
            )}
            <Status style={{ background: statusObj?.color }}>
              {statusObj?.name}{' '}
              {statusObj === StatusDownload.PROCESSING &&
                record.jobProgress > 0 &&
                `(${record.jobProgress}%)`}
            </Status>
            {statusObj === StatusDownload.FAILED && (
              <RoundButton
                hint="Visualizar Erro"
                onClick={() => setError(record.error)}
              >
                <MdRemoveRedEye size={18} />
              </RoundButton>
            )}
          </ContainerStatus>
        </WrapperStatus>
      </td>
      <td>
        {statusObj === StatusDownload.COMPLETED && (
          <RoundButton hint="Download" onClick={() => handleDownload(record)}>
            <MdDownload size={18} />
          </RoundButton>
        )}
      </td>
    </tr>
  );
};

export default DownloadRow;
